<template>
  <v-dialog
    v-model="session_expired"
    persistent
    max-width="450px"
  >
    <v-card>
      <v-card-title class="text-h5">
        Parece que sua sessão expirou.
      </v-card-title>
      <v-card-text>
        Recarregue a página para continuar ou faça login novamente.
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="green darken-1"
          text
          @click="onConfirm"
        >
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState, mapActions } from 'vuex';

export default {
  computed:{
    ...mapState({
      session_expired: state => state.session_expired,
    }),
  },
  methods:{
    ...mapActions([
      'isLoading'
    ]),
    onConfirm(){
      this.isLoading();
      window.location = "/";
    }
  }
}
</script>

